import * as ActionTypes from 'actions';

const initialState = {
  data: {},
};

export default function(state = initialState, action = {}) {
  const { id, response, type } = action;

  switch (type) {
  case ActionTypes.CACHE_API_RESPONSE: {
    const newState = Object.assign({}, state);
    newState.data[id] = response;
    return newState;
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/apiCache.js